import Component from './protected-route';
export default Component;
